import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { TaskService } from 'src/app/service/common/task.service';

@Component({
  selector: 'app-task-modal',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.css']
})
export class TaskModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  priorities : any;

  constructor(
    private supportService : SupportService,
    private msgService : MessageService,
    private taskService : TaskService,
    private dialogRef : MatDialogRef<TaskModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    
    this._subs.add(
      this.supportService.getNames('priorities').subscribe(res => {
        if(res.status == 'ok'){
          this.priorities = res.data;
        }
      })
    )
  }

  saveTask(taskData){
    taskData.modelId = this.data.modelId;
    taskData.modelName = this.data.modelName;

    this._subs.add(
      this.taskService.saveTask(taskData).subscribe(res=> {

        if(res.status == 'ok'){
          this.msgService.success(res.message);
          this.dialogRef.close(res.data);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
